module.exports = __webpack_public_path__ + "img/left.be9c148c.jpg";